import { render, staticRenderFns } from "./CardsViewTable.vue?vue&type=template&id=90a01c3a&lang=pug&"
import script from "./CardsViewTable.vue?vue&type=script&lang=js&"
export * from "./CardsViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports